import { createFeatureSelector } from '@ngrx/store';
import { CreateShowDataState } from './create-show.reducer';

export const createShowDataState = createFeatureSelector<CreateShowDataState>('createShow');
export { CreateShowDataState };
